import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import moment from 'moment';
import classNames from 'classnames';

import {
    Alert,
    Col,
    Container,
    Row,
    Table
} from "reactstrap";

import LazyImage from "../../components/media/images/LazyImage";
import warning from '../../assets/svg/icons/warning.svg';
import danger from '../../assets/svg/icons/danger.svg';

import PolyUtil from '../../util/PolyUtil';

class CompactListing extends Component {
    render() {
        const {roommateGroupSize, listing} = this.props;
        const securityDeposit = PolyUtil.formatUSD(listing.security_deposit);

        const {bedrooms, bathrooms, max_tenants} = listing.prop;

        const address = PolyUtil.getPropertyStreetAddress(listing.prop);
        const city = PolyUtil.getPropertyCity(listing.prop);
        const state = PolyUtil.getPropertyState(listing.prop);

        const leaseStart = moment(listing.lease_start).format("MM/DD/YYYY");
        const leaseLength = listing.lease_length;

        const description = listing.description;

        let url = listing.prop.image;

        if (url === null) {
            url = PolyUtil.buildStreetViewUrl(600, 350, address + "," + city + "," + state);
        }

        const maxClassName = classNames({
            'text-danger': roommateGroupSize > max_tenants,
        });

        const brClassName = classNames({
            'text-warning': roommateGroupSize < bedrooms,
        });

        return (
            <Container fluid>
                <Row>
                    <Col xs={12} md={7}>
                        <LazyImage className="mobile-mb-1" src={url} style={{borderRadius: '15px'}}/>
                    </Col>
                    <Col xs={12} md={5}>
                        <Table size="sm">
                            <tbody>
                            <tr>
                                <td>Bedrooms</td>
                                <th scope="row" className={brClassName}>{bedrooms}</th>
                            </tr>
                            <tr>
                                <td>Bathrooms</td>
                                <th scope="row">{bathrooms}</th>
                            </tr>
                            <tr>
                                <td>Max Tenants</td>
                                <th scope="row" className={maxClassName}>{max_tenants}</th>
                            </tr>
                            <tr>
                                <td>Rent</td>
                                <th scope="row">{PolyUtil.formatUSD(listing.rent)}</th>
                            </tr>
                            <tr>
                                <td>Security Deposit</td>
                                <th scope="row">{securityDeposit}</th>
                            </tr>
                            <tr>
                                <td>Lease Start</td>
                                <th scope="row">{leaseStart}</th>
                            </tr>
                            <tr>
                                <td>Lease Duration</td>
                                <th scope="row">{leaseLength + " Months"}</th>
                            </tr>
                            </tbody>
                        </Table>
                    </Col>
                </Row>
                {
                    description !== "" &&
                    <Row>
                        <Col>
                            <p style={{whiteSpace: "pre-wrap"}}>{description}</p>
                        </Col>
                    </Row>
                }
                <Row>
                    <Col>
                        {
                            roommateGroupSize > max_tenants ? (
                                <Alert color="danger" className="text-center mb-0 d-flex justify-content-around align-items-center">
                                    <div className="mr-2">
                                        <img src={danger} height="35px" role="presentation"/>
                                    </div>
                                    <div>
                                        This property allows for a maximum of {max_tenants} tenant{max_tenants !== 1 && 's'}, but your group
                                        has {roommateGroupSize} {roommateGroupSize === 1 ? 'person' : 'people'} in it. You won't be able to
                                        apply to this property unless you change up your group.
                                    </div>
                                </Alert>
                            ) : roommateGroupSize < bedrooms ? (
                                <Alert color="warning" className="text-center mb-0 d-flex justify-content-around align-items-center">
                                    <div className="mr-2">
                                        <img src={warning} height="35px" role="presentation"/>
                                    </div>
                                    <div>
                                        This property has {bedrooms} bedroom{bedrooms !== 1 && 's'}, but you have {roommateGroupSize} {roommateGroupSize === 1 ? 'person' : 'people'} in your group.
                                        Make sure you've got your whole group together before applying to this listing.
                                    </div>
                                </Alert>
                            ) : null
                        }
                    </Col>
                </Row>
            </Container>
        );
    }
}

CompactListing.propTypes = {
    listing: PropTypes.object.isRequired,
};

const mapStateToProps = (state, props) => ({
    roommateGroupSize: state.tenant.roommate_group.roommates.length,
});

export default connect(mapStateToProps)(CompactListing);



// WEBPACK FOOTER //
// ./src/containers/listings/CompactListing.js